export default __webpack_public_path__ + "static/media/ID_NEWYORK_SERGE LIGHTMAN.15d1519b.jpg";